<template>
    <div>
        <div class="steps__title">{{ title }}</div>
        <div class="steps">
            <template v-for="(_, index) in items">
                <div class="steps__item"
                    :class="{ 'steps__item--complete': index < current, 'steps__item--active': index === current }">
                    <div class="steps__item-circle">
                        <div class="steps__item-inner-circle">
                            {{ index + 1 }}
                        </div>
                    </div>
                </div>
                <div class="steps__item-divider" :class="{ 'steps__item-divider--complete': index >= current }"
                    v-if="index != items.length - 1">
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: Array,
        current: Number
    },
    computed: {
        title() {
            const item = this.items[this.current]
            return item
        }
    }
}
</script>

<style lang="css">
.steps__title {
    text-align: center;

}

.steps {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: white;
    padding: 16px;
}

.steps__item {
    --step-color-rgb: 193, 193, 193;
}

.steps__item-circle {
    background-color: rgba(var(--step-color-rgb), 0.25);
    padding: 5px;
    border-radius: 50%;
}

.steps__item--active {
    --step-color-rgb: 255, 193, 7;
}

.steps__item--complete {
    --step-color-rgb: 8, 74, 184;
}

.steps__item-inner-circle {
    background-color: rgba(var(--step-color-rgb), 1);
    width: 26px;
    height: 26px;
    text-align: center;
    border-radius: 50%;
}

.steps__item-divider--complete {
    background-color: rgba(8, 74, 184, 1);
}

.steps__item-divider {
    background-color: #c1c1c1;
    height: 1px;
    flex: 1;
    margin: 0 4px;
}
</style>